[
  {
    "name": [
      {
        "name": "Afghanistan",
        "key": "EN"
      },
      {
        "name": "أفغانستان",
        "key": "AR"
      }
    ],
    "key": "Afghanistan",
    "countryCode": "93"
  },
  {
    "name": [
      {
        "name": "Albania",
        "key": "EN"
      },
      {
        "name": "ألبانيا",
        "key": "AR"
      }
    ],
    "key": "Albania",
    "countryCode": "355"
  },
  {
    "name": [
      {
        "name": "Algeria",
        "key": "EN"
      },
      {
        "name": "الجزائر",
        "key": "AR"
      }
    ],
    "key": "Algeria",
    "countryCode": "213"
  },
  {
    "name": [
      {
        "name": "AmericanSamoa",
        "key": "EN"
      },
      {
        "name": "ساموا الأمريكية",
        "key": "AR"
      }
    ],
    "key": "AmericanSamoa",
    "countryCode": "1 684"
  },
  {
    "name": [
      {
        "name": "Andorra",
        "key": "EN"
      },
      {
        "name": "أندورا",
        "key": "AR"
      }
    ],
    "key": "Andorra",
    "countryCode": "376"
  },
  {
    "name": [
      {
        "name": "Angola",
        "key": "EN"
      },
      {
        "name": "أنجولا",
        "key": "AR"
      }
    ],
    "key": "Angola",
    "countryCode": "244"
  },
  {
    "name": [
      {
        "name": "Anguilla",
        "key": "EN"
      },
      {
        "name": "أنغيلا",
        "key": "AR"
      }
    ],
    "key": "Anguilla",
    "countryCode": "1 264"
  },
  {
    "name": [
      {
        "name": "Antarctica",
        "key": "EN"
      },
      {
        "name": "أنتاركتيكا",
        "key": "AR"
      }
    ],
    "key": "Antarctica",
    "countryCode": ""
  },
  {
    "name": [
      {
        "name": "Antigua and Barbuda",
        "key": "EN"
      },
      {
        "name": "أنتيغوا وباربودا",
        "key": "AR"
      }
    ],
    "key": "Antigua and Barbuda",
    "countryCode": "1268"
  },
  {
    "name": [
      {
        "name": "Argentina",
        "key": "EN"
      },
      {
        "name": "الأرجنتين",
        "key": "AR"
      }
    ],
    "key": "Argentina",
    "countryCode": "54"
  },
  {
    "name": [
      {
        "name": "Armenia",
        "key": "EN"
      },
      {
        "name": "أرمينيا",
        "key": "AR"
      }
    ],
    "key": "Armenia",
    "countryCode": "374"
  },
  {
    "name": [
      {
        "name": "Aruba",
        "key": "EN"
      },
      {
        "name": "آروبا",
        "key": "AR"
      }
    ],
    "key": "Aruba",
    "countryCode": "297"
  },
  {
    "name": [
      {
        "name": "Australia",
        "key": "EN"
      },
      {
        "name": "أستراليا",
        "key": "AR"
      }
    ],
    "key": "Australia",
    "countryCode": "61"
  },
  {
    "name": [
      {
        "name": "Austria",
        "key": "EN"
      },
      {
        "name": "النمسا",
        "key": "AR"
      }
    ],
    "key": "Austria",
    "countryCode": "43"
  },
  {
    "name": [
      {
        "name": "Azerbaijan",
        "key": "EN"
      },
      {
        "name": "أذربيجان",
        "key": "AR"
      }
    ],
    "key": "Azerbaijan",
    "countryCode": "994"
  },
  {
    "name": [
      {
        "name": "Bahamas",
        "key": "EN"
      },
      {
        "name": "البهاما",
        "key": "AR"
      }
    ],
    "key": "Bahamas",
    "countryCode": "1 242"
  },
  {
    "name": [
      {
        "name": "Bahrain",
        "key": "EN"
      },
      {
        "name": "البحرين",
        "key": "AR"
      }
    ],
    "key": "Bahrain",
    "countryCode": "973"
  },
  {
    "name": [
      {
        "name": "Bangladesh",
        "key": "EN"
      },
      {
        "name": "بنجلاديش",
        "key": "AR"
      }
    ],
    "key": "Bangladesh",
    "countryCode": "880"
  },
  {
    "name": [
      {
        "name": "Barbados",
        "key": "EN"
      },
      {
        "name": "باربادوس",
        "key": "AR"
      }
    ],
    "key": "Barbados",
    "countryCode": "1 246"
  },
  {
    "name": [
      {
        "name": "Belarus",
        "key": "EN"
      },
      {
        "name": "روسيا البيضاء",
        "key": "AR"
      }
    ],
    "key": "Belarus",
    "countryCode": "375"
  },
  {
    "name": [
      {
        "name": "Belgium",
        "key": "EN"
      },
      {
        "name": "بلجيكا",
        "key": "AR"
      }
    ],
    "key": "Belgium",
    "countryCode": "32"
  },
  {
    "name": [
      {
        "name": "Belize",
        "key": "EN"
      },
      {
        "name": "بليز",
        "key": "AR"
      }
    ],
    "key": "Belize",
    "countryCode": "501"
  },
  {
    "name": [
      {
        "name": "Benin",
        "key": "EN"
      },
      {
        "name": "بنين",
        "key": "AR"
      }
    ],
    "key": "Benin",
    "countryCode": "229"
  },
  {
    "name": [
      {
        "name": "Bermuda",
        "key": "EN"
      },
      {
        "name": "برمودا",
        "key": "AR"
      }
    ],
    "key": "Bermuda",
    "countryCode": "1 441"
  },
  {
    "name": [
      {
        "name": "Bhutan",
        "key": "EN"
      },
      {
        "name": "بوتان",
        "key": "AR"
      }
    ],
    "key": "Bhutan",
    "countryCode": "975"
  },
  {
    "name": [
      {
        "name": "Bolivia",
        "key": "EN"
      },
      {
        "name": "بوليفيا",
        "key": "AR"
      }
    ],
    "key": "Bolivia",
    "countryCode": "591"
  },
  {
    "name": [
      {
        "name": "Borkina Faso",
        "key": "EN"
      },
      {
        "name": "بوركينا فاسو",
        "key": "AR"
      }
    ],
    "key": "Borkina Faso",
    "countryCode": "0"
  },
  {
    "name": [
      {
        "name": "Bosnia and Herzegovina",
        "key": "EN"
      },
      {
        "name": "البوسنة والهرسك",
        "key": "AR"
      }
    ],
    "key": "Bosnia and Herzegovina",
    "countryCode": "387"
  },
  {
    "name": [
      {
        "name": "Botswana",
        "key": "EN"
      },
      {
        "name": "بتسوانا",
        "key": "AR"
      }
    ],
    "key": "Botswana",
    "countryCode": "267"
  },
  {
    "name": [
      {
        "name": "Brazil",
        "key": "EN"
      },
      {
        "name": "البرازيل",
        "key": "AR"
      }
    ],
    "key": "Brazil",
    "countryCode": "55"
  },
  {
    "name": [
      {
        "name": "British Indian Ocean Territory",
        "key": "EN"
      },
      {
        "name": "المحيط الهندي البريطاني",
        "key": "AR"
      }
    ],
    "key": "British Indian Ocean Territory",
    "countryCode": "246"
  },
  {
    "name": [
      {
        "name": "Brunei Darussalam",
        "key": "EN"
      },
      {
        "name": "بروناي",
        "key": "AR"
      }
    ],
    "key": "Brunei Darussalam",
    "countryCode": "673"
  },
  {
    "name": [
      {
        "name": "Bulgaria",
        "key": "EN"
      },
      {
        "name": "بلغاريا",
        "key": "AR"
      }
    ],
    "key": "Bulgaria",
    "countryCode": "359"
  },
  {
    "name": [
      {
        "name": "Burkina Faso",
        "key": "EN"
      },
      {
        "name": "بوركينا فاسو",
        "key": "AR"
      }
    ],
    "key": "Burkina Faso",
    "countryCode": "226"
  },
  {
    "name": [
      {
        "name": "Burundi",
        "key": "EN"
      },
      {
        "name": "بوروندي",
        "key": "AR"
      }
    ],
    "key": "Burundi",
    "countryCode": "257"
  },
  {
    "name": [
      {
        "name": "Cambodia",
        "key": "EN"
      },
      {
        "name": "كمبوديا",
        "key": "AR"
      }
    ],
    "key": "Cambodia",
    "countryCode": "855"
  },
  {
    "name": [
      {
        "name": "Cameroon",
        "key": "EN"
      },
      {
        "name": "الكاميرون",
        "key": "AR"
      }
    ],
    "key": "Cameroon",
    "countryCode": "237"
  },
  {
    "name": [
      {
        "name": "Canada",
        "key": "EN"
      },
      {
        "name": "أنتيجوا وبربودا",
        "key": "AR"
      }
    ],
    "key": "Canada",
    "countryCode": "1"
  },
  {
    "name": [
      {
        "name": "Cape Verde",
        "key": "EN"
      },
      {
        "name": "الرأس الأخضر",
        "key": "AR"
      }
    ],
    "key": "Cape Verde",
    "countryCode": "238"
  },
  {
    "name": [
      {
        "name": "Cayman Islands",
        "key": "EN"
      },
      {
        "name": "جزر كايمان",
        "key": "AR"
      }
    ],
    "key": "Cayman Islands",
    "countryCode": "345"
  },
  {
    "name": [
      {
        "name": "Central African Republic",
        "key": "EN"
      },
      {
        "name": "جمهورية افريقيا الوسطى",
        "key": "AR"
      }
    ],
    "key": "Central African Republic",
    "countryCode": "236"
  },
  {
    "name": [
      {
        "name": "Chad",
        "key": "EN"
      },
      {
        "name": "تشاد",
        "key": "AR"
      }
    ],
    "key": "Chad",
    "countryCode": "235"
  },
  {
    "name": [
      {
        "name": "Chile",
        "key": "EN"
      },
      {
        "name": "شيلي",
        "key": "AR"
      }
    ],
    "key": "Chile",
    "countryCode": "56"
  },
  {
    "name": [
      {
        "name": "China",
        "key": "EN"
      },
      {
        "name": "الصين",
        "key": "AR"
      }
    ],
    "key": "China",
    "countryCode": "86"
  },
  {
    "name": [
      {
        "name": "Colombia",
        "key": "EN"
      },
      {
        "name": "كولومبيا",
        "key": "AR"
      }
    ],
    "key": "Colombia",
    "countryCode": "57"
  },
  {
    "name": [
      {
        "name": "Comoros",
        "key": "EN"
      },
      {
        "name": "جزر القمر",
        "key": "AR"
      }
    ],
    "key": "Comoros",
    "countryCode": "269"
  },
  {
    "name": [
      {
        "name": "Congo",
        "key": "EN"
      },
      {
        "name": "الكونغو - برازافيل",
        "key": "AR"
      }
    ],
    "key": "Congo",
    "countryCode": "242"
  },
  {
    "name": [
      {
        "name": "Cook Islands",
        "key": "EN"
      },
      {
        "name": "جزر كوك",
        "key": "AR"
      }
    ],
    "key": "Cook Islands",
    "countryCode": "682"
  },
  {
    "name": [
      {
        "name": "Costa Rica",
        "key": "EN"
      },
      {
        "name": "كوستاريكا",
        "key": "AR"
      }
    ],
    "key": "Costa Rica",
    "countryCode": "506"
  },
  {
    "name": [
      {
        "name": "Cote d'Ivoire",
        "key": "EN"
      },
      {
        "name": "ساحل العاج",
        "key": "AR"
      }
    ],
    "key": "Cote d'Ivoire",
    "countryCode": "225"
  },
  {
    "name": [
      {
        "name": "Croatia",
        "key": "EN"
      },
      {
        "name": "كرواتيا",
        "key": "AR"
      }
    ],
    "key": "Croatia",
    "countryCode": "385"
  },
  {
    "name": [
      {
        "name": "Cuba",
        "key": "EN"
      },
      {
        "name": "كوبا",
        "key": "AR"
      }
    ],
    "key": "Cuba",
    "countryCode": "53"
  },
  {
    "name": [
      {
        "name": "Cyprus",
        "key": "EN"
      },
      {
        "name": "قبرص",
        "key": "AR"
      }
    ],
    "key": "Cyprus",
    "countryCode": "537"
  },
  {
    "name": [
      {
        "name": "Czech Republic",
        "key": "EN"
      },
      {
        "name": "جمهورية التشيك",
        "key": "AR"
      }
    ],
    "key": "Czech Republic",
    "countryCode": "420"
  },
  {
    "name": [
      {
        "name": "Democratic People's Republic of Korea",
        "key": "EN"
      },
      {
        "name": "كوريا الشمالية",
        "key": "AR"
      }
    ],
    "key": "Democratic People's Republic of Korea",
    "countryCode": "850"
  },
  {
    "name": [
      {
        "name": "Denmark",
        "key": "EN"
      },
      {
        "name": "الدانمرك",
        "key": "AR"
      }
    ],
    "key": "Denmark",
    "countryCode": "45"
  },
  {
    "name": [
      {
        "name": "Displaced Tribes",
        "key": "EN"
      },
      {
        "name": "",
        "key": "AR"
      }
    ],
    "key": "Displaced Tribes",
    "countryCode": "0"
  },
  {
    "name": [
      {
        "name": "Djibouti",
        "key": "EN"
      },
      {
        "name": "جيبوتي",
        "key": "AR"
      }
    ],
    "key": "Djibouti",
    "countryCode": "253"
  },
  {
    "name": [
      {
        "name": "Dominica",
        "key": "EN"
      },
      {
        "name": "دومينيكا",
        "key": "AR"
      }
    ],
    "key": "Dominica",
    "countryCode": "1 767"
  },
  {
    "name": [
      {
        "name": "Dominican Republic",
        "key": "EN"
      },
      {
        "name": "جمهورية الدومينيكان",
        "key": "AR"
      }
    ],
    "key": "Dominican Republic",
    "countryCode": "1 849"
  },
  {
    "name": [
      {
        "name": "Ecuador",
        "key": "EN"
      },
      {
        "name": "الاكوادور",
        "key": "AR"
      }
    ],
    "key": "Ecuador",
    "countryCode": "593"
  },
  {
    "name": [
      {
        "name": "Egypt",
        "key": "EN"
      },
      {
        "name": "مصر",
        "key": "AR"
      }
    ],
    "key": "Egypt",
    "countryCode": "20"
  },
  {
    "name": [
      {
        "name": "El Salvador",
        "key": "EN"
      },
      {
        "name": "السلفادور",
        "key": "AR"
      }
    ],
    "key": "El Salvador",
    "countryCode": "503"
  },
  {
    "name": [
      {
        "name": "Equatorial Guinea",
        "key": "EN"
      },
      {
        "name": "غينيا الاستوائية",
        "key": "AR"
      }
    ],
    "key": "Equatorial Guinea",
    "countryCode": "240"
  },
  {
    "name": [
      {
        "name": "Eritrea",
        "key": "EN"
      },
      {
        "name": "اريتريا",
        "key": "AR"
      }
    ],
    "key": "Eritrea",
    "countryCode": "291"
  },
  {
    "name": [
      {
        "name": "Estonia",
        "key": "EN"
      },
      {
        "name": "استونيا",
        "key": "AR"
      }
    ],
    "key": "Estonia",
    "countryCode": "372"
  },
  {
    "name": [
      {
        "name": "Ethiopia",
        "key": "EN"
      },
      {
        "name": "اثيوبيا",
        "key": "AR"
      }
    ],
    "key": "Ethiopia",
    "countryCode": "251"
  },
  {
    "name": [
      {
        "name": "Falkland Islands (Malvinas)",
        "key": "EN"
      },
      {
        "name": "جزر فوكلاند",
        "key": "AR"
      }
    ],
    "key": "Falkland Islands (Malvinas)",
    "countryCode": "500"
  },
  {
    "name": [
      {
        "name": "Faroe Islands",
        "key": "EN"
      },
      {
        "name": "جزر فارو",
        "key": "AR"
      }
    ],
    "key": "Faroe Islands",
    "countryCode": "298"
  },
  {
    "name": [
      {
        "name": "Fiji",
        "key": "EN"
      },
      {
        "name": "فيجي",
        "key": "AR"
      }
    ],
    "key": "Fiji",
    "countryCode": "679"
  },
  {
    "name": [
      {
        "name": "Finland",
        "key": "EN"
      },
      {
        "name": "جزر أولان",
        "key": "AR"
      }
    ],
    "key": "Finland",
    "countryCode": "358"
  },
  {
    "name": [
      {
        "name": "France",
        "key": "EN"
      },
      {
        "name": "فرنسا",
        "key": "AR"
      }
    ],
    "key": "France",
    "countryCode": "33"
  },
  {
    "name": [
      {
        "name": "French Guiana",
        "key": "EN"
      },
      {
        "name": "غويانا",
        "key": "AR"
      }
    ],
    "key": "French Guiana",
    "countryCode": "594"
  },
  {
    "name": [
      {
        "name": "French Polynesia",
        "key": "EN"
      },
      {
        "name": "بولينيزيا الفرنسية",
        "key": "AR"
      }
    ],
    "key": "French Polynesia",
    "countryCode": "689"
  },
  {
    "name": [
      {
        "name": "Gabon",
        "key": "EN"
      },
      {
        "name": "الجابون",
        "key": "AR"
      }
    ],
    "key": "Gabon",
    "countryCode": "241"
  },
  {
    "name": [
      {
        "name": "Gambia",
        "key": "EN"
      },
      {
        "name": "غامبيا",
        "key": "AR"
      }
    ],
    "key": "Gambia",
    "countryCode": "220"
  },
  {
    "name": [
      {
        "name": "Georgia",
        "key": "EN"
      },
      {
        "name": "جورجيا",
        "key": "AR"
      }
    ],
    "key": "Georgia",
    "countryCode": "995"
  },
  {
    "name": [
      {
        "name": "Germany",
        "key": "EN"
      },
      {
        "name": "ألمانيا",
        "key": "AR"
      }
    ],
    "key": "Germany",
    "countryCode": "49"
  },
  {
    "name": [
      {
        "name": "Ghana",
        "key": "EN"
      },
      {
        "name": "غانا",
        "key": "AR"
      }
    ],
    "key": "Ghana",
    "countryCode": "233"
  },
  {
    "name": [
      {
        "name": "Gibraltar",
        "key": "EN"
      },
      {
        "name": "جبل طارق",
        "key": "AR"
      }
    ],
    "key": "Gibraltar",
    "countryCode": "350"
  },
  {
    "name": [
      {
        "name": "Greece",
        "key": "EN"
      },
      {
        "name": "اليونان",
        "key": "AR"
      }
    ],
    "key": "Greece",
    "countryCode": "30"
  },
  {
    "name": [
      {
        "name": "Greenland",
        "key": "EN"
      },
      {
        "name": "جرينلاند",
        "key": "AR"
      }
    ],
    "key": "Greenland",
    "countryCode": "299"
  },
  {
    "name": [
      {
        "name": "Grenada",
        "key": "EN"
      },
      {
        "name": "غرينادا",
        "key": "AR"
      }
    ],
    "key": "Grenada",
    "countryCode": "1 473"
  },
  {
    "name": [
      {
        "name": "Guadeloupe",
        "key": "EN"
      },
      {
        "name": "جوادلوب",
        "key": "AR"
      }
    ],
    "key": "Guadeloupe",
    "countryCode": "590"
  },
  {
    "name": [
      {
        "name": "Guam",
        "key": "EN"
      },
      {
        "name": "غوام",
        "key": "AR"
      }
    ],
    "key": "Guam",
    "countryCode": "1 671"
  },
  {
    "name": [
      {
        "name": "Guatemala",
        "key": "EN"
      },
      {
        "name": "جواتيمالا",
        "key": "AR"
      }
    ],
    "key": "Guatemala",
    "countryCode": "502"
  },
  {
    "name": [
      {
        "name": "Guernsey",
        "key": "EN"
      },
      {
        "name": "غيرنسي",
        "key": "AR"
      }
    ],
    "key": "Guernsey",
    "countryCode": "44"
  },
  {
    "name": [
      {
        "name": "Guinea",
        "key": "EN"
      },
      {
        "name": "غينيا",
        "key": "AR"
      }
    ],
    "key": "Guinea",
    "countryCode": "224"
  },
  {
    "name": [
      {
        "name": "Guinea-Bissau",
        "key": "EN"
      },
      {
        "name": "غينيا بيساو",
        "key": "AR"
      }
    ],
    "key": "Guinea-Bissau",
    "countryCode": "245"
  },
  {
    "name": [
      {
        "name": "Guyana",
        "key": "EN"
      },
      {
        "name": "غيانا",
        "key": "AR"
      }
    ],
    "key": "Guyana",
    "countryCode": "595"
  },
  {
    "name": [
      {
        "name": "Haiti",
        "key": "EN"
      },
      {
        "name": "هايتي",
        "key": "AR"
      }
    ],
    "key": "Haiti",
    "countryCode": "509"
  },
  {
    "name": [
      {
        "name": "Holy See (Vatican City State)",
        "key": "EN"
      },
      {
        "name": "الفاتيكان",
        "key": "AR"
      }
    ],
    "key": "Holy See (Vatican City State)",
    "countryCode": "379"
  },
  {
    "name": [
      {
        "name": "Honduras",
        "key": "EN"
      },
      {
        "name": "هندوراس",
        "key": "AR"
      }
    ],
    "key": "Honduras",
    "countryCode": "504"
  },
  {
    "name": [
      {
        "name": "Hong Kong",
        "key": "EN"
      },
      {
        "name": "هونج كونج الصينية",
        "key": "AR"
      }
    ],
    "key": "Hong Kong",
    "countryCode": "852"
  },
  {
    "name": [
      {
        "name": "Hungary",
        "key": "EN"
      },
      {
        "name": "المجر",
        "key": "AR"
      }
    ],
    "key": "Hungary",
    "countryCode": "36"
  },
  {
    "name": [
      {
        "name": "Iceland",
        "key": "EN"
      },
      {
        "name": "أيسلندا",
        "key": "AR"
      }
    ],
    "key": "Iceland",
    "countryCode": "354"
  },
  {
    "name": [
      {
        "name": "India",
        "key": "EN"
      },
      {
        "name": "الهند",
        "key": "AR"
      }
    ],
    "key": "India",
    "countryCode": "91"
  },
  {
    "name": [
      {
        "name": "Indonesia",
        "key": "EN"
      },
      {
        "name": "اندونيسيا",
        "key": "AR"
      }
    ],
    "key": "Indonesia",
    "countryCode": "62"
  },
  {
    "name": [
      {
        "name": "Iran",
        "key": "EN"
      },
      {
        "name": "ايران",
        "key": "AR"
      }
    ],
    "key": "Iran",
    "countryCode": "98"
  },
  {
    "name": [
      {
        "name": "Iraq",
        "key": "EN"
      },
      {
        "name": "العراق",
        "key": "AR"
      }
    ],
    "key": "Iraq",
    "countryCode": "964"
  },
  {
    "name": [
      {
        "name": "Ireland",
        "key": "EN"
      },
      {
        "name": "أيرلندا",
        "key": "AR"
      }
    ],
    "key": "Ireland",
    "countryCode": "353"
  },
  {
    "name": [
      {
        "name": "Italy",
        "key": "EN"
      },
      {
        "name": "ايطاليا",
        "key": "AR"
      }
    ],
    "key": "Italy",
    "countryCode": "39"
  },
  {
    "name": [
      {
        "name": "Jamaica",
        "key": "EN"
      },
      {
        "name": "جامايكا",
        "key": "AR"
      }
    ],
    "key": "Jamaica",
    "countryCode": "1 876"
  },
  {
    "name": [
      {
        "name": "Japan",
        "key": "EN"
      },
      {
        "name": "اليابان",
        "key": "AR"
      }
    ],
    "key": "Japan",
    "countryCode": "81"
  },
  {
    "name": [
      {
        "name": "Jordan",
        "key": "EN"
      },
      {
        "name": "الأردن",
        "key": "AR"
      }
    ],
    "key": "Jordan",
    "countryCode": "962"
  },
  {
    "name": [
      {
        "name": "Kazakhstan",
        "key": "EN"
      },
      {
        "name": "كازاخستان",
        "key": "AR"
      }
    ],
    "key": "Kazakhstan",
    "countryCode": "7-7"
  },
  {
    "name": [
      {
        "name": "Kenya",
        "key": "EN"
      },
      {
        "name": "كينيا",
        "key": "AR"
      }
    ],
    "key": "Kenya",
    "countryCode": "254"
  },
  {
    "name": [
      {
        "name": "Kiribati",
        "key": "EN"
      },
      {
        "name": "كيريباتي",
        "key": "AR"
      }
    ],
    "key": "Kiribati",
    "countryCode": "686"
  },
  {
    "name": [
      {
        "name": "Kuwait",
        "key": "EN"
      },
      {
        "name": "الكويت",
        "key": "AR"
      }
    ],
    "key": "Kuwait",
    "countryCode": "965"
  },
  {
    "name": [
      {
        "name": "Kyrgyzstan",
        "key": "EN"
      },
      {
        "name": "قرغيزستان",
        "key": "AR"
      }
    ],
    "key": "Kyrgyzstan",
    "countryCode": "996"
  },
  {
    "name": [
      {
        "name": "Lao People's Democratic Republic",
        "key": "EN"
      },
      {
        "name": "لاوس",
        "key": "AR"
      }
    ],
    "key": "Lao People's Democratic Republic",
    "countryCode": "856"
  },
  {
    "name": [
      {
        "name": "Latvia",
        "key": "EN"
      },
      {
        "name": "لاتفيا",
        "key": "AR"
      }
    ],
    "key": "Latvia",
    "countryCode": "371"
  },
  {
    "name": [
      {
        "name": "Lebanon",
        "key": "EN"
      },
      {
        "name": "لبنان",
        "key": "AR"
      }
    ],
    "key": "Lebanon",
    "countryCode": "961"
  },
  {
    "name": [
      {
        "name": "Lesotho",
        "key": "EN"
      },
      {
        "name": "ليسوتو",
        "key": "AR"
      }
    ],
    "key": "Lesotho",
    "countryCode": "266"
  },
  {
    "name": [
      {
        "name": "Liberia",
        "key": "EN"
      },
      {
        "name": "ليبيريا",
        "key": "AR"
      }
    ],
    "key": "Liberia",
    "countryCode": "231"
  },
  {
    "name": [
      {
        "name": "Libyan Arab Jamahiriya",
        "key": "EN"
      },
      {
        "name": "ليبيا",
        "key": "AR"
      }
    ],
    "key": "Libyan Arab Jamahiriya",
    "countryCode": "218"
  },
  {
    "name": [
      {
        "name": "Liechtenstein",
        "key": "EN"
      },
      {
        "name": "ليختنشتاين",
        "key": "AR"
      }
    ],
    "key": "Liechtenstein",
    "countryCode": "423"
  },
  {
    "name": [
      {
        "name": "Lithuania",
        "key": "EN"
      },
      {
        "name": "ليتوانيا",
        "key": "AR"
      }
    ],
    "key": "Lithuania",
    "countryCode": "370"
  },
  {
    "name": [
      {
        "name": "Luxembourg",
        "key": "EN"
      },
      {
        "name": "لوكسمبورج",
        "key": "AR"
      }
    ],
    "key": "Luxembourg",
    "countryCode": "352"
  },
  {
    "name": [
      {
        "name": "Macao",
        "key": "EN"
      },
      {
        "name": "ماكاو الصينية",
        "key": "AR"
      }
    ],
    "key": "Macao",
    "countryCode": "853"
  },
  {
    "name": [
      {
        "name": "Macedonia",
        "key": "EN"
      },
      {
        "name": "مقدونيا",
        "key": "AR"
      }
    ],
    "key": "Macedonia",
    "countryCode": "389"
  },
  {
    "name": [
      {
        "name": "Madagascar",
        "key": "EN"
      },
      {
        "name": "مدغشقر",
        "key": "AR"
      }
    ],
    "key": "Madagascar",
    "countryCode": "261"
  },
  {
    "name": [
      {
        "name": "Malawi",
        "key": "EN"
      },
      {
        "name": "ملاوي",
        "key": "AR"
      }
    ],
    "key": "Malawi",
    "countryCode": "265"
  },
  {
    "name": [
      {
        "name": "Malaysia",
        "key": "EN"
      },
      {
        "name": "ماليزيا",
        "key": "AR"
      }
    ],
    "key": "Malaysia",
    "countryCode": "60"
  },
  {
    "name": [
      {
        "name": "Maldives",
        "key": "EN"
      },
      {
        "name": "جزر الملديف",
        "key": "AR"
      }
    ],
    "key": "Maldives",
    "countryCode": "960"
  },
  {
    "name": [
      {
        "name": "Mali",
        "key": "EN"
      },
      {
        "name": "مالي",
        "key": "AR"
      }
    ],
    "key": "Mali",
    "countryCode": "223"
  },
  {
    "name": [
      {
        "name": "Malta",
        "key": "EN"
      },
      {
        "name": "مالطا",
        "key": "AR"
      }
    ],
    "key": "Malta",
    "countryCode": "356"
  },
  {
    "name": [
      {
        "name": "Marshall Islands",
        "key": "EN"
      },
      {
        "name": "جزر المارشال",
        "key": "AR"
      }
    ],
    "key": "Marshall Islands",
    "countryCode": "692"
  },
  {
    "name": [
      {
        "name": "Martinique",
        "key": "EN"
      },
      {
        "name": "مارتينيك",
        "key": "AR"
      }
    ],
    "key": "Martinique",
    "countryCode": "596"
  },
  {
    "name": [
      {
        "name": "Mauritania",
        "key": "EN"
      },
      {
        "name": "موريتانيا",
        "key": "AR"
      }
    ],
    "key": "Mauritania",
    "countryCode": "222"
  },
  {
    "name": [
      {
        "name": "Mauritius",
        "key": "EN"
      },
      {
        "name": "موريشيوس",
        "key": "AR"
      }
    ],
    "key": "Mauritius",
    "countryCode": "230"
  },
  {
    "name": [
      {
        "name": "Mayotte",
        "key": "EN"
      },
      {
        "name": "روينيون",
        "key": "AR"
      }
    ],
    "key": "Mayotte",
    "countryCode": "262"
  },
  {
    "name": [
      {
        "name": "Mexico",
        "key": "EN"
      },
      {
        "name": "المكسيك",
        "key": "AR"
      }
    ],
    "key": "Mexico",
    "countryCode": "52"
  },
  {
    "name": [
      {
        "name": "Micronesia",
        "key": "EN"
      },
      {
        "name": "ميكرونيزيا",
        "key": "AR"
      }
    ],
    "key": "Micronesia",
    "countryCode": "691"
  },
  {
    "name": [
      {
        "name": "Monaco",
        "key": "EN"
      },
      {
        "name": "موناكو",
        "key": "AR"
      }
    ],
    "key": "Monaco",
    "countryCode": "377"
  },
  {
    "name": [
      {
        "name": "Mongolia",
        "key": "EN"
      },
      {
        "name": "منغوليا",
        "key": "AR"
      }
    ],
    "key": "Mongolia",
    "countryCode": "976"
  },
  {
    "name": [
      {
        "name": "Montenegro",
        "key": "EN"
      },
      {
        "name": "الجبل الأسود",
        "key": "AR"
      }
    ],
    "key": "Montenegro",
    "countryCode": "382"
  },
  {
    "name": [
      {
        "name": "Montserrat",
        "key": "EN"
      },
      {
        "name": "مونتسيرات",
        "key": "AR"
      }
    ],
    "key": "Montserrat",
    "countryCode": "1664"
  },
  {
    "name": [
      {
        "name": "Morocco",
        "key": "EN"
      },
      {
        "name": "المغرب",
        "key": "AR"
      }
    ],
    "key": "Morocco",
    "countryCode": "212"
  },
  {
    "name": [
      {
        "name": "Mozambique",
        "key": "EN"
      },
      {
        "name": "موزمبيق",
        "key": "AR"
      }
    ],
    "key": "Mozambique",
    "countryCode": "258"
  },
  {
    "name": [
      {
        "name": "Myanmar",
        "key": "EN"
      },
      {
        "name": "ميانمار",
        "key": "AR"
      }
    ],
    "key": "Myanmar",
    "countryCode": "95"
  },
  {
    "name": [
      {
        "name": "Namibia",
        "key": "EN"
      },
      {
        "name": "ناميبيا",
        "key": "AR"
      }
    ],
    "key": "Namibia",
    "countryCode": "264"
  },
  {
    "name": [
      {
        "name": "Nauru",
        "key": "EN"
      },
      {
        "name": "نورو",
        "key": "AR"
      }
    ],
    "key": "Nauru",
    "countryCode": "674"
  },
  {
    "name": [
      {
        "name": "Nepal",
        "key": "EN"
      },
      {
        "name": "نيبال",
        "key": "AR"
      }
    ],
    "key": "Nepal",
    "countryCode": "977"
  },
  {
    "name": [
      {
        "name": "Netherlands",
        "key": "EN"
      },
      {
        "name": "هولندا",
        "key": "AR"
      }
    ],
    "key": "Netherlands",
    "countryCode": "31"
  },
  {
    "name": [
      {
        "name": "Netherlands Antilles",
        "key": "EN"
      },
      {
        "name": "جزر الأنتيل الهولندية",
        "key": "AR"
      }
    ],
    "key": "Netherlands Antilles",
    "countryCode": "599"
  },
  {
    "name": [
      {
        "name": "New Caledonia",
        "key": "EN"
      },
      {
        "name": "كاليدونيا الجديدة",
        "key": "AR"
      }
    ],
    "key": "New Caledonia",
    "countryCode": "687"
  },
  {
    "name": [
      {
        "name": "New Zealand",
        "key": "EN"
      },
      {
        "name": "نيوزيلاندا",
        "key": "AR"
      }
    ],
    "key": "New Zealand",
    "countryCode": "64"
  },
  {
    "name": [
      {
        "name": "Nicaragua",
        "key": "EN"
      },
      {
        "name": "نيكاراجوا",
        "key": "AR"
      }
    ],
    "key": "Nicaragua",
    "countryCode": "505"
  },
  {
    "name": [
      {
        "name": "Niger",
        "key": "EN"
      },
      {
        "name": "النيجر",
        "key": "AR"
      }
    ],
    "key": "Niger",
    "countryCode": "227"
  },
  {
    "name": [
      {
        "name": "Nigeria",
        "key": "EN"
      },
      {
        "name": "نيجيريا",
        "key": "AR"
      }
    ],
    "key": "Nigeria",
    "countryCode": "234"
  },
  {
    "name": [
      {
        "name": "Niue",
        "key": "EN"
      },
      {
        "name": "نيوي",
        "key": "AR"
      }
    ],
    "key": "Niue",
    "countryCode": "683"
  },
  {
    "name": [
      {
        "name": "Norfolk Island",
        "key": "EN"
      },
      {
        "name": "جزيرة نورفولك",
        "key": "AR"
      }
    ],
    "key": "Norfolk Island",
    "countryCode": "672"
  },
  {
    "name": [
      {
        "name": "Northern Mariana Islands",
        "key": "EN"
      },
      {
        "name": "جزر مريانا الشمالية",
        "key": "AR"
      }
    ],
    "key": "Northern Mariana Islands",
    "countryCode": "1 670"
  },
  {
    "name": [
      {
        "name": "Norway",
        "key": "EN"
      },
      {
        "name": "النرويج",
        "key": "AR"
      }
    ],
    "key": "Norway",
    "countryCode": "47"
  },
  {
    "name": [
      {
        "name": "Oman",
        "key": "EN"
      },
      {
        "name": "عمان",
        "key": "AR"
      }
    ],
    "key": "Oman",
    "countryCode": "968"
  },
  {
    "name": [
      {
        "name": "Pakistan",
        "key": "EN"
      },
      {
        "name": "باكستان",
        "key": "AR"
      }
    ],
    "key": "Pakistan",
    "countryCode": "92"
  },
  {
    "name": [
      {
        "name": "Palau",
        "key": "EN"
      },
      {
        "name": "بالاو",
        "key": "AR"
      }
    ],
    "key": "Palau",
    "countryCode": "680"
  },
  {
    "name": [
      {
        "name": "Palestine",
        "key": "EN"
      },
      {
        "name": "فلسطين",
        "key": "AR"
      }
    ],
    "key": "Palestine",
    "countryCode": "970"
  },
  {
    "name": [
      {
        "name": "Panama",
        "key": "EN"
      },
      {
        "name": "بنما",
        "key": "AR"
      }
    ],
    "key": "Panama",
    "countryCode": "507"
  },
  {
    "name": [
      {
        "name": "Papua New Guinea",
        "key": "EN"
      },
      {
        "name": "بابوا غينيا الجديدة",
        "key": "AR"
      }
    ],
    "key": "Papua New Guinea",
    "countryCode": "675"
  },
  {
    "name": [
      {
        "name": "Peru",
        "key": "EN"
      },
      {
        "name": "بيرو",
        "key": "AR"
      }
    ],
    "key": "Peru",
    "countryCode": "51"
  },
  {
    "name": [
      {
        "name": "Philippines",
        "key": "EN"
      },
      {
        "name": "الفيلبين",
        "key": "AR"
      }
    ],
    "key": "Philippines",
    "countryCode": "63"
  },
  {
    "name": [
      {
        "name": "Pitcairn",
        "key": "EN"
      },
      {
        "name": "بتكايرن",
        "key": "AR"
      }
    ],
    "key": "Pitcairn",
    "countryCode": "872"
  },
  {
    "name": [
      {
        "name": "Poland",
        "key": "EN"
      },
      {
        "name": "بولندا",
        "key": "AR"
      }
    ],
    "key": "Poland",
    "countryCode": "48"
  },
  {
    "name": [
      {
        "name": "Portugal",
        "key": "EN"
      },
      {
        "name": "البرتغال",
        "key": "AR"
      }
    ],
    "key": "Portugal",
    "countryCode": "351"
  },
  {
    "name": [
      {
        "name": "Puerto Rico",
        "key": "EN"
      },
      {
        "name": "بورتوريكو",
        "key": "AR"
      }
    ],
    "key": "Puerto Rico",
    "countryCode": "1 939"
  },
  {
    "name": [
      {
        "name": "Qatar",
        "key": "EN"
      },
      {
        "name": "قطر",
        "key": "AR"
      }
    ],
    "key": "Qatar",
    "countryCode": "974"
  },
  {
    "name": [
      {
        "name": "Republic of Korea ",
        "key": "EN"
      },
      {
        "name": "كوريا الجنوبية",
        "key": "AR"
      }
    ],
    "key": "Republic of Korea ",
    "countryCode": "82"
  },
  {
    "name": [
      {
        "name": "Republic of Moldova",
        "key": "EN"
      },
      {
        "name": "مولدافيا",
        "key": "AR"
      }
    ],
    "key": "Republic of Moldova",
    "countryCode": "373"
  },
  {
    "name": [
      {
        "name": "Romania",
        "key": "EN"
      },
      {
        "name": "رومانيا",
        "key": "AR"
      }
    ],
    "key": "Romania",
    "countryCode": "40"
  },
  {
    "name": [
      {
        "name": "Russia",
        "key": "EN"
      },
      {
        "name": "روسيا",
        "key": "AR"
      }
    ],
    "key": "Russia",
    "countryCode": "7"
  },
  {
    "name": [
      {
        "name": "Rwanda",
        "key": "EN"
      },
      {
        "name": "رواندا",
        "key": "AR"
      }
    ],
    "key": "Rwanda",
    "countryCode": "250"
  },
  {
    "name": [
      {
        "name": "Saint Helena, Ascension and Tristan Da Cunha",
        "key": "EN"
      },
      {
        "name": "سانت هيلنا",
        "key": "AR"
      }
    ],
    "key": "Saint Helena, Ascension and Tristan Da Cunha",
    "countryCode": "290"
  },
  {
    "name": [
      {
        "name": "Saint Kitts and Nevis",
        "key": "EN"
      },
      {
        "name": "سانت كيتس ونيفيس",
        "key": "AR"
      }
    ],
    "key": "Saint Kitts and Nevis",
    "countryCode": "1 869"
  },
  {
    "name": [
      {
        "name": "Saint Lucia",
        "key": "EN"
      },
      {
        "name": "القديسة لوسيا",
        "key": "AR"
      }
    ],
    "key": "Saint Lucia",
    "countryCode": "1 758"
  },
  {
    "name": [
      {
        "name": "Saint Pierre and Miquelon",
        "key": "EN"
      },
      {
        "name": "سانت بيير وميكولون",
        "key": "AR"
      }
    ],
    "key": "Saint Pierre and Miquelon",
    "countryCode": "508"
  },
  {
    "name": [
      {
        "name": "Saint Vincent and the Grenadines",
        "key": "EN"
      },
      {
        "name": "سانت فنسنت وجزر غرينادين",
        "key": "AR"
      }
    ],
    "key": "Saint Vincent and the Grenadines",
    "countryCode": "1 784"
  },
  {
    "name": [
      {
        "name": "Samoa",
        "key": "EN"
      },
      {
        "name": "ساموا",
        "key": "AR"
      }
    ],
    "key": "Samoa",
    "countryCode": "685"
  },
  {
    "name": [
      {
        "name": "San Marino",
        "key": "EN"
      },
      {
        "name": "سان مارينو",
        "key": "AR"
      }
    ],
    "key": "San Marino",
    "countryCode": "378"
  },
  {
    "name": [
      {
        "name": "Sao Tome and Principe",
        "key": "EN"
      },
      {
        "name": "ساو تومي وبرينسيبي",
        "key": "AR"
      }
    ],
    "key": "Sao Tome and Principe",
    "countryCode": "239"
  },
  {
    "name": [
      {
        "name": "Saudi Arabia",
        "key": "EN"
      },
      {
        "name": "المملكة العربية السعودية",
        "key": "AR"
      }
    ],
    "key": "Saudi Arabia",
    "countryCode": "966"
  },
  {
    "name": [
      {
        "name": "Senegal",
        "key": "EN"
      },
      {
        "name": "السنغال",
        "key": "AR"
      }
    ],
    "key": "Senegal",
    "countryCode": "221"
  },
  {
    "name": [
      {
        "name": "Serbia",
        "key": "EN"
      },
      {
        "name": "صربيا",
        "key": "AR"
      }
    ],
    "key": "Serbia",
    "countryCode": "381"
  },
  {
    "name": [
      {
        "name": "Seychelles",
        "key": "EN"
      },
      {
        "name": "سيشل",
        "key": "AR"
      }
    ],
    "key": "Seychelles",
    "countryCode": "248"
  },
  {
    "name": [
      {
        "name": "Sierra Leone",
        "key": "EN"
      },
      {
        "name": "سيراليون",
        "key": "AR"
      }
    ],
    "key": "Sierra Leone",
    "countryCode": "232"
  },
  {
    "name": [
      {
        "name": "Singapore",
        "key": "EN"
      },
      {
        "name": "سنغافورة",
        "key": "AR"
      }
    ],
    "key": "Singapore",
    "countryCode": "65"
  },
  {
    "name": [
      {
        "name": "Slovakia",
        "key": "EN"
      },
      {
        "name": "سلوفاكيا",
        "key": "AR"
      }
    ],
    "key": "Slovakia",
    "countryCode": "421"
  },
  {
    "name": [
      {
        "name": "Slovenia",
        "key": "EN"
      },
      {
        "name": "سلوفينيا",
        "key": "AR"
      }
    ],
    "key": "Slovenia",
    "countryCode": "386"
  },
  {
    "name": [
      {
        "name": "Solomon Islands",
        "key": "EN"
      },
      {
        "name": "جزر سليمان",
        "key": "AR"
      }
    ],
    "key": "Solomon Islands",
    "countryCode": "677"
  },
  {
    "name": [
      {
        "name": "Somalia",
        "key": "EN"
      },
      {
        "name": "الصومال",
        "key": "AR"
      }
    ],
    "key": "Somalia",
    "countryCode": "252"
  },
  {
    "name": [
      {
        "name": "South Africa",
        "key": "EN"
      },
      {
        "name": "جمهورية جنوب افريقيا",
        "key": "AR"
      }
    ],
    "key": "South Africa",
    "countryCode": "27"
  },
  {
    "name": [
      {
        "name": "Spain",
        "key": "EN"
      },
      {
        "name": "أسبانيا",
        "key": "AR"
      }
    ],
    "key": "Spain",
    "countryCode": "34"
  },
  {
    "name": [
      {
        "name": "Sri Lanka",
        "key": "EN"
      },
      {
        "name": "سريلانكا",
        "key": "AR"
      }
    ],
    "key": "Sri Lanka",
    "countryCode": "94"
  },
  {
    "name": [
      {
        "name": "Sudan",
        "key": "EN"
      },
      {
        "name": "السودان",
        "key": "AR"
      }
    ],
    "key": "Sudan",
    "countryCode": "249"
  },
  {
    "name": [
      {
        "name": "Suriname",
        "key": "EN"
      },
      {
        "name": "سورينام",
        "key": "AR"
      }
    ],
    "key": "Suriname",
    "countryCode": "597"
  },
  {
    "name": [
      {
        "name": "Swaziland",
        "key": "EN"
      },
      {
        "name": "سوازيلاند",
        "key": "AR"
      }
    ],
    "key": "Swaziland",
    "countryCode": "268"
  },
  {
    "name": [
      {
        "name": "Sweden",
        "key": "EN"
      },
      {
        "name": "السويد",
        "key": "AR"
      }
    ],
    "key": "Sweden",
    "countryCode": "46"
  },
  {
    "name": [
      {
        "name": "Switzerland",
        "key": "EN"
      },
      {
        "name": "سويسرا",
        "key": "AR"
      }
    ],
    "key": "Switzerland",
    "countryCode": "41"
  },
  {
    "name": [
      {
        "name": "Syrian Arab Republic",
        "key": "EN"
      },
      {
        "name": "سوريا",
        "key": "AR"
      }
    ],
    "key": "Syrian Arab Republic",
    "countryCode": "963"
  },
  {
    "name": [
      {
        "name": "Taiwan",
        "key": "EN"
      },
      {
        "name": "تايوان",
        "key": "AR"
      }
    ],
    "key": "Taiwan",
    "countryCode": "886"
  },
  {
    "name": [
      {
        "name": "Tajikistan",
        "key": "EN"
      },
      {
        "name": "طاجكستان",
        "key": "AR"
      }
    ],
    "key": "Tajikistan",
    "countryCode": "992"
  },
  {
    "name": [
      {
        "name": "Thailand",
        "key": "EN"
      },
      {
        "name": "تايلند",
        "key": "AR"
      }
    ],
    "key": "Thailand",
    "countryCode": "66"
  },
  {
    "name": [
      {
        "name": "The Democratic Republic of the Congo",
        "key": "EN"
      },
      {
        "name": "جمهورية الكونغو الديمقراطية",
        "key": "AR"
      }
    ],
    "key": "The Democratic Republic of the Congo",
    "countryCode": "243"
  },
  {
    "name": [
      {
        "name": "Timor-Leste",
        "key": "EN"
      },
      {
        "name": "تيمور الشرقية",
        "key": "AR"
      }
    ],
    "key": "Timor-Leste",
    "countryCode": "670"
  },
  {
    "name": [
      {
        "name": "Togo",
        "key": "EN"
      },
      {
        "name": "توجو",
        "key": "AR"
      }
    ],
    "key": "Togo",
    "countryCode": "228"
  },
  {
    "name": [
      {
        "name": "Tokelau",
        "key": "EN"
      },
      {
        "name": "توكيلو",
        "key": "AR"
      }
    ],
    "key": "Tokelau",
    "countryCode": "690"
  },
  {
    "name": [
      {
        "name": "Tonga",
        "key": "EN"
      },
      {
        "name": "تونجا",
        "key": "AR"
      }
    ],
    "key": "Tonga",
    "countryCode": "676"
  },
  {
    "name": [
      {
        "name": "Trinidad and Tobago",
        "key": "EN"
      },
      {
        "name": "ترينداد وتوباغو",
        "key": "AR"
      }
    ],
    "key": "Trinidad and Tobago",
    "countryCode": "1 868"
  },
  {
    "name": [
      {
        "name": "Tunisia",
        "key": "EN"
      },
      {
        "name": "تونس",
        "key": "AR"
      }
    ],
    "key": "Tunisia",
    "countryCode": "216"
  },
  {
    "name": [
      {
        "name": "Turkey",
        "key": "EN"
      },
      {
        "name": "تركيا",
        "key": "AR"
      }
    ],
    "key": "Turkey",
    "countryCode": "90"
  },
  {
    "name": [
      {
        "name": "Turkmenistan",
        "key": "EN"
      },
      {
        "name": "تركمانستان",
        "key": "AR"
      }
    ],
    "key": "Turkmenistan",
    "countryCode": "993"
  },
  {
    "name": [
      {
        "name": "Turks and Caicos Islands",
        "key": "EN"
      },
      {
        "name": "جزر تركس وكايكوس",
        "key": "AR"
      }
    ],
    "key": "Turks and Caicos Islands",
    "countryCode": "1 649"
  },
  {
    "name": [
      {
        "name": "Tuvalu",
        "key": "EN"
      },
      {
        "name": "توفالو",
        "key": "AR"
      }
    ],
    "key": "Tuvalu",
    "countryCode": "688"
  },
  {
    "name": [
      {
        "name": "Uganda",
        "key": "EN"
      },
      {
        "name": "أوغندا",
        "key": "AR"
      }
    ],
    "key": "Uganda",
    "countryCode": "256"
  },
  {
    "name": [
      {
        "name": "Ukraine",
        "key": "EN"
      },
      {
        "name": "أوكرانيا",
        "key": "AR"
      }
    ],
    "key": "Ukraine",
    "countryCode": "380"
  },
  {
    "name": [
      {
        "name": "United Arab Emirates",
        "key": "EN"
      },
      {
        "name": "الامارات العربية المتحدة",
        "key": "AR"
      }
    ],
    "key": "United Arab Emirates",
    "countryCode": "971"
  },
  {
    "name": [
      {
        "name": "United Kingdom",
        "key": "EN"
      },
      {
        "name": "المملكة المتحدة",
        "key": "AR"
      }
    ],
    "key": "United Kingdom",
    "countryCode": "44"
  },
  {
    "name": [
      {
        "name": "United States of America",
        "key": "EN"
      },
      {
        "name": "الولايات المتحدة الأمريكية",
        "key": "AR"
      }
    ],
    "key": "United States of America",
    "countryCode": "1"
  },
  {
    "name": [
      {
        "name": "United Republic of Tanzania",
        "key": "EN"
      },
      {
        "name": "تانزانيا",
        "key": "AR"
      }
    ],
    "key": "United Republic of Tanzania",
    "countryCode": "255"
  },
  {
    "name": [
      {
        "name": "Unspecified",
        "key": "EN"
      },
      {
        "name": "غير محددي الجنسية",
        "key": "AR"
      }
    ],
    "key": "Unspecified",
    "countryCode": "0"
  },
  {
    "name": [
      {
        "name": "Uruguay",
        "key": "EN"
      },
      {
        "name": "أورجواي",
        "key": "AR"
      }
    ],
    "key": "Uruguay",
    "countryCode": "598"
  },
  {
    "name": [
      {
        "name": "Uzbekistan",
        "key": "EN"
      },
      {
        "name": "أوزبكستان",
        "key": "AR"
      }
    ],
    "key": "Uzbekistan",
    "countryCode": "998"
  },
  {
    "name": [
      {
        "name": "Vanuatu",
        "key": "EN"
      },
      {
        "name": "فانواتو",
        "key": "AR"
      }
    ],
    "key": "Vanuatu",
    "countryCode": "678"
  },
  {
    "name": [
      {
        "name": "Venezuela",
        "key": "EN"
      },
      {
        "name": "فنزويلا",
        "key": "AR"
      }
    ],
    "key": "Venezuela",
    "countryCode": "58"
  },
  {
    "name": [
      {
        "name": "Viet Nam",
        "key": "EN"
      },
      {
        "name": "فيتنام",
        "key": "AR"
      }
    ],
    "key": "Viet Nam",
    "countryCode": "84"
  },
  {
    "name": [
      {
        "name": "Virgin Islands, British",
        "key": "EN"
      },
      {
        "name": "جزر العذراء البريطانية",
        "key": "AR"
      }
    ],
    "key": "Virgin Islands, British",
    "countryCode": "1 284"
  },
  {
    "name": [
      {
        "name": "Virgin Islands, U.S.",
        "key": "EN"
      },
      {
        "name": "جزر فيرجن الأمريكي",
        "key": "AR"
      }
    ],
    "key": "Virgin Islands, U.S.",
    "countryCode": "1 340"
  },
  {
    "name": [
      {
        "name": "Wallis and Futuna",
        "key": "EN"
      },
      {
        "name": "جزر والس وفوتونا",
        "key": "AR"
      }
    ],
    "key": "Wallis and Futuna",
    "countryCode": "681"
  },
  {
    "name": [
      {
        "name": "Yemen",
        "key": "EN"
      },
      {
        "name": "اليمن",
        "key": "AR"
      }
    ],
    "key": "Yemen",
    "countryCode": "967"
  },
  {
    "name": [
      {
        "name": "Zambia",
        "key": "EN"
      },
      {
        "name": "زامبيا",
        "key": "AR"
      }
    ],
    "key": "Zambia",
    "countryCode": "260"
  },
  {
    "name": [
      {
        "name": "Zimbabwe",
        "key": "EN"
      },
      {
        "name": "زيمبابوي",
        "key": "AR"
      }
    ],
    "key": "Zimbabwe",
    "countryCode": "263"
  }
]